import MapGoogle from './MapGoogle';

export default MapGoogle;
